import { useCallback, useEffect, useSyncExternalStore } from "react";
import { REF_KEYS, fetchRef, getRef, getRefVersion, subscribeRef } from "./refDataStore";

// Reference-data lists for Payment Desk forms. Each list loads on its own
// and is remembered for the session (see refDataStore.js). Lists carry only
// what pickers need (id + name; vendors also category_code and the
// bank-complete flag). `loadingLists.<name>` is true until that list's first
// load finishes; `refresh(keys)` quietly re-fetches.
export function usePaymentDeskRefData() {
  useSyncExternalStore(subscribeRef, getRefVersion);
  useEffect(() => { REF_KEYS.forEach((k) => fetchRef(k)); }, []);
  const refresh = useCallback((keys = REF_KEYS) => Promise.all(keys.map((k) => fetchRef(k, { force: true }))), []);

  const out = { refresh, loadingLists: {} };
  REF_KEYS.forEach((k) => {
    const s = getRef(k);
    out[k] = s.data;
    out.loadingLists[k] = !s.loaded;
  });
  out.loading = REF_KEYS.some((k) => out.loadingLists[k]);
  return out;
}
